export const COLLAPSE_LEFT_PANE_WIDTH = 0;
export const MIN_LEFT_PANE_WIDTH = 200;

export const TAB_HEIGHT = 40;
export const COLLAPSE_SECTION_HEIGHT = 120;
export const MIN_SECTION_HEIGHT = 60;
export const MIN_SECTION_HEIGHT_EXAM_DETAILS = MIN_SECTION_HEIGHT + TAB_HEIGHT;
export const COLLAPSE_SECTION_HEIGHT_EXAM_DETAILS = COLLAPSE_SECTION_HEIGHT + TAB_HEIGHT;

export const TOOLBAR_HEIGHT_SPACING = 60;

export const TOP_TABS_HEIGHT = '12rem';

export const TAB_CONTENT_ADJUSTMENT_HEIGHT = 70;
